// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wl-table.el-table{font-size:14px}.wl-thead>th{background:#f5f7fa;color:#333;text-align:center}.pagination-container{margin-top:8px}", ""]);
// Exports
module.exports = exports;
